import { CommonModule } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ContactRequest } from '@app/models/account.model';
import { ContactFormGroup } from '@app/models/form.models';
import { GetLocalizedPipe } from '@app/pipes/get-localized.pipe';
import { GenericStore } from '@app/stores/generic.store';
import { ButtonComponent } from '@app/ui-components/button/button.component';
import { ValidatedDropdownComponent } from '@app/ui-components/validated-dropdown/validated-dropdown.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { buildContactForm } from './add-contact-modal.helper';

@Component({
  selector: 'app-add-contact-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    GetLocalizedPipe,
    ValidatedInputComponent,
    ValidatedDropdownComponent,
    ButtonComponent,
  ],
  templateUrl: './add-contact-modal.component.html',
  styleUrl: './add-contact-modal.component.scss',
})
export class AddContactModalComponent {
  protected genericStore = inject(GenericStore);

  open = input<boolean>(false);
  title = input<string>('Add Contact');

  close = output<void>();
  submit = output<ContactRequest>();

  private fb = inject(FormBuilder);
  store = inject(GenericStore);

  form: ContactFormGroup = buildContactForm(this.fb);
  submitting = signal(false);

  get hasMismatch(): boolean {
    return !!this.form.errors?.['mismatch'];
  }

  onCancel(): void {
    this.close.emit();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitting.set(true);
    const v = this.form.getRawValue();
    const payload: ContactRequest = {
      password: v.password,
      confirmPassword: v.confirmPassword,
      titleCode: v.titleCode,
      firstName: v.firstName,
      middleName: v.middleName,
      lastName: v.lastName,
      phone: v.phoneNumber,
    };
    this.submit.emit(payload);
    this.submitting.set(false);
  }
}
